$(function () {
	var www = $(window).width();
	var hhh = $(window).height();
	var preTop;

	if($("product-recommendations").length>=1){
		//console.log(1111);

/*
		$("product-recommendations").on('DOMSubtreeModified', function(){
			var tmpHtml = $("product-recommendations .recoList").html();
			console.log(tmpHtml);
			
			if(tmpHtml != undefined){
				$("#headerLike").html(tmpHtml);
				$("#headerLikeSec").show();
			}
		});
*/
		
		const observer = new MutationObserver(mutationList =>  
			mutationList.filter(m => m.type === 'childList').forEach(m => {  
				m.addedNodes.forEach(doSomething);  
			}));
		
		var target = $("product-recommendations");
		observer.observe(target[0],{childList: true, subtree: true}); 

	}
	
	function doSomething(){
		var tmpHtml = $("product-recommendations .recoList").html();
		//console.log(tmpHtml);
		
		if(tmpHtml != undefined){
			$("#headerLike").html(tmpHtml);
			$("#headerLikeSec").show();
		}
	}

	/*-------------------------------------
WISHLIST
-------------------------------------*/
	var wishlistTimer;
	if ($("#mainContent #wishlist-hero-shared-list-loader").length >= 1) {
		wishlistTimer = setInterval(function () {
			if ($(".wishlisthero-customer-view-listing").length >= 1) {
				$(".wishlist-hero-page-header").removeAttr("style");
				$(".MuiTypography-root").removeAttr("style");
				clearInterval(wishlistTimer);
			}
		}, 10);
	}

	/*-------------------------------------
SEARCH
-------------------------------------*/
	if($(".filterBox").length>=1){
		//console.log("filterBox");
		
		
		var nowURL = new URL(window.location.href);
		//console.log(url);
		var nowParams = nowURL.searchParams;
		//console.log(nowParams);
		
		//variationFilter=COLOR
		var variationFlg = nowParams.get("variationFilter");
		//console.log(variationFlg);
		
		if(variationFlg=="COLOR"){
			$(".itemList li").not(".variant1").hide();
		}

		var regularFlg = nowParams.get("regularFilter");
		//console.log(variationFlg);
		
		if(regularFlg=="REGULAR"){
			$(".itemList li.salePriceClass").hide();
		}



		
		$('.searchFormJamiray input[type="checkbox"]').each(function (index) {
			var tmpInput = $(this);

			nowParams.forEach((value, key) => {
				if(tmpInput.val()==value){
					//console.log(value);
					tmpInput.prop("checked",true);
				}
			});
		});

		$(".onlyOneFilter input").click(function () {	
			var box = $(this).closest(".filterList");
			box.find("input").not(this).prop("checked",false);

			//return false;
		});

		$("#filterSearch").click(function () {			
			var filterURL = "";
			var filterArr = [];
			var url = new URL(window.location.href);
			//console.log(url);
			var params = url.searchParams;
			
			var sortParam = nowParams.get("sort_by");
			
			if(sortParam!=""){
				var tmpURL = "sort_by="+sortParam;
				filterArr.push(tmpURL);	
			}

			$('.searchFormJamiray input[name="product_type"]:checked').each(function (index) {
				var tmp = $(this);
				var name = tmp.attr("name");
				var val = tmp.attr("value");
				
/*
				if(val=="OTHERS"){
					var tmpURL = "filter.p."+name+"=VASE";
					filterArr.push(tmpURL);

					var tmpURL = "filter.p."+name+"=BANGLE";
					filterArr.push(tmpURL);
				}else{
					var tmpURL = "filter.p."+name+"="+val;
					filterArr.push(tmpURL);					
				}
*/

				var tmpURL = "filter.p."+name+"="+val;
				filterArr.push(tmpURL);					
				
				
				//console.log(tmpURL);
			});

			$('.searchFormJamiray input[name="tag"]:checked').each(function (index) {
				var tmp = $(this);
				var name = tmp.attr("name");
				var val = tmp.attr("value");
				
				var tmpURL = "filter.p."+name+"="+val;
				filterArr.push(tmpURL);
				
				//console.log(tmpURL);
			});
			
			$('.searchFormJamiray input[name="availability"]:checked').each(function (index) {
				var tmp = $(this);
				var name = tmp.attr("name");
				var val = tmp.attr("value");
				
				var tmpURL = "filter.v."+name+"="+val;
				filterArr.push(tmpURL);
				
				//console.log(tmpURL);
			});

/*
			$('.searchFormJamiray input[name="color"]:checked').each(function (index) {
				var tmp = $(this);
				var name = tmp.attr("name");
				var val = tmp.attr("value");
				
				var tmpURL = "filter.v.option."+name+"="+val;
				filterArr.push(tmpURL);
				
				//console.log(tmpURL);
			});
*/

			$('.searchFormJamiray input[name="regular"]:checked').each(function (index) {
				var tmp = $(this);
				var name = tmp.attr("name");
				var val = tmp.attr("value");
				
				var tmpURL = "regularFilter="+val;
				filterArr.push(tmpURL);
				
				//console.log(tmpURL);
			});

			$('.searchFormJamiray input[name="sort"]:checked').each(function (index) {
				var tmp = $(this);
				var name = tmp.attr("name");
				var val = tmp.attr("value");
				
				var tmpURL = "variationFilter="+val;
				filterArr.push(tmpURL);
				
				//console.log(tmpURL);
			});
			
			var result = filterArr.join('&');
			//console.log(result);
			
			
			//filterURL = url["origin"]+url["pathname"]+"?"+result;
			filterURL = url["origin"]+"/collections/all"+"?"+result;
			
			//console.log(filterURL);
			
			window.location.href = filterURL;
			
			return false;
		});

		$(".filterSelect a").click(function () {	
			var url = new URL(window.location.href);
			var filterLink = $(this).attr("href");
			//console.log(url);
			var params = url.searchParams;
			//console.log(params);
			
			if(params.size>=1){
				//filterURL = url["origin"]+url["pathname"]+url["search"]+"&"+filterLink;
				//url.searchParams.append('sort_by', filterLink);
			}else{
				//filterURL = url["origin"]+url["pathname"]+"?"+filterLink;
			}
			
			url.searchParams.set('sort_by', filterLink);
			console.log(url);
			
			window.location.href = url;

			return false;
		});		
		
	}

	/*-------------------------------------
SCROLL
-------------------------------------*/

	$(window).on("resize", adjustScroll);

	//scroll
	var scrollTimer;
	$(window).bind("scroll touchmove", function () {
		clearInterval(scrollTimer);
		scrollTimer = setInterval(function () {
			adjustScroll();
			clearInterval(scrollTimer);
		}, 10);
	});
	//adjustScroll();

	var preDocViewTop = 0;
	var docViewTop = 0;
	var hideFlg = true;

	function adjustScroll() {
		docViewTop = $(window).scrollTop();
		hhh = $(window).height();
		www = $(window).width();

		//console.log(docViewTop);
		//console.log(preDocViewTop);

		if (hideFlg) {
			//if (docViewTop > preDocViewTop && docViewTop > 60) {
			if (docViewTop > hhh / 3) {
				$("header").addClass("whiteBg");
				//$("#button_container").addClass("hide");
			} else {
				$("header").removeClass("whiteBg");
				//$("#button_container").removeClass("hide");
			}
		}
		if ($("header").hasClass("scrollHeader")) {
			//if (docViewTop > preDocViewTop && docViewTop > 60) {
			if (docViewTop > hhh / 3) {
				$("header").addClass("scrollHeaderShow");
			} else {
				$("header").removeClass("scrollHeaderShow");
			}
		}

		if ($(".mainVisual").not(".lookMainVisual").length >= 1) {
			//console.log("top mainVisual");

			if (docViewTop > hhh * 1.5) {
				$(".mainVisual").addClass("fadeout");
			} else {
				$(".mainVisual").removeClass("fadeout");
			}
		}

		preDocViewTop = docViewTop;
	}

	/*-------------------------------------
MENU
-------------------------------------*/

	if ($(".bnrBox").length >= 1) {
		var tmp = $(".bnrBox").clone();

		$("#MainContent .bnrBox").remove();

		$("#MainContent").before(tmp);

		$(".bnrBox .bnrClose").click(function () {
			$(".bnrBox").fadeOut(300);

			return false;
		});
	}

	$("#button_container").click(function () {
		$("html,body").toggleClass("hiddenBox");
		$("#toggle").toggleClass("active");
		$("#overlay").toggleClass("open");
		$("header").toggleClass("menuOpen");

		$("#bgWhite").stop().fadeToggle(300);
	});

	// $("#overlay ul li a").click(function () {
	// 	$("#toggle").removeClass("active");
	// 	$("#overlay").removeClass("open");
	// });

	$(".subListBtnOpen").click(function () {
		var box = $(this).closest(".navSpList");
		box.find(".subList").slideToggle(300);

		return false;
	});
	$(".openFtNav").click(function () {
		$(this).toggleClass("active");
		var box = $(this).closest(".ftNavEach");
		box.find(".ftNavListHidden").slideToggle(300);

		return false;
	});

	$(".acOpenBtn").click(function () {
		var box = $(this).next(".desp");

		$(".acList li .desp").not(box).slideUp(300);

		box.slideToggle(300);

		return false;
	});

	/*-------------------------------------
mainvisual
-------------------------------------*/
	if ($(".mainVisual").length >= 1) {
		var nowPercent = 0;
		var displayingPercent = 0;
		var loadImgNum = 0;
		var loadedImgNum = 0;
		loadImgNum = $(".mainVisual img").length;

		if ($(".mainVisual").hasClass("lookMainVisual")) {
			console.log("lookMainVisual");

			$("header").addClass("scrollHeader");
		}

		// const topSwiper = new Swiper(".topSlider", {
		// 	// Optional parameters
		// 	direction: "horizontal",
		// 	loop: true,
		// 	autoplay: {
		// 		delay: 3000,
		// 		disableOnInteraction: true,
		// 	},
		// 	speed: 1400,
		// 	effect: "fade",
		// 	spaceBetween: 0,
		// 	slidesPerView: 1,
		// 	centeredSlides: true,
		// 	slideToClickedSlide: true,

		// 	// If we need pagination
		// 	/*
		// 	pagination: {
		// 		el: '.swiper-pagination',
		// 	},
		// */

		// 	// Navigation arrows
		// 	/*
		// 	navigation: {
		// 		nextEl: '.productSwiper .swiper-button-next',
		// 		prevEl: '.productSwiper .swiper-button-prev',
		// 	},
		// */

		// 	// And if we need scrollbar
		// 	/*
		// 	scrollbar: {
		// 		el: '.backupSwiperControl .swiper-scrollbar',
		// 		draggable: true,
		// 	},
		// */

		// 	breakpoints: {
		// 		/*
		// 		719: {
		// 			slidesPerView: 'auto',
		// 			spaceBetween: 0,
		// 			centeredSlides: true,
		// 		},
		// */
		// 	},
		// });

		// topSwiper.autoplay.stop();

		//読み込んだらカウント
		$(".mainVisual img").each(function (index) {
			$(this).imagesLoaded(function () {
				loadedImgNum++;
				//console.log(loadedImgNum);

				$(window).trigger("resize");
			});
		});

		//$("html,body").addClass("hidden");

		// LOADING
		var checkload = function (ev) {
			nowPercent = Math.ceil((100 * loadedImgNum) / loadImgNum);
			//console.log(displayingPercent);

			if (displayingPercent >= 100) {
				//console.log("complete");

				setTimeout(showBg, 0);

				//setTimeout(startSlider, 1600);

				//30分/3
				//Cookies.set('firstFlg', "show", {expires: 1/24 * 0.5/3 });
			} else {
				setTimeout(checkload, 10);

				if (displayingPercent < nowPercent) {
					//本当のパーセントで表示させたい時
					displayingPercent = Math.ceil((100 * loadedImgNum) / loadImgNum) + 1;

					//ちょっと遅延表示させたい時
					if (displayingPercent < nowPercent) {
						//displayingPercent = displayingPercent + 2;
					}
				}
			}
		};
		var timer = setTimeout(checkload, 10);

		function showBg() {
			$(".mainVisual").addClass("active");
		}
	}

	/*-------------------------------------
HEADER
-------------------------------------*/

	if ($(".mainVisual").length == 0) {
		$("header").addClass("whiteBgAb");
	}

	var tabTimer;

	$(".tabBtnHover").hover(
		function () {
			clearInterval(tabTimer);

			var linkBtn = $(this);
			$(".tabBtn").not(linkBtn).removeClass("activeTab");
			linkBtn.addClass("activeTab");

			var target = linkBtn.data("tab");
			target = "#" + target;
			target = $(target);

			//open
			$(".tabBox").not(target).hide();

			target.stop().fadeIn(300);
			$("#bgWhite").stop().fadeIn(300);
			$("header").addClass("whiteBgTab");
		},
		function () {
			fadeOutTab();
		},
	);
	$(".containerFadeTab").hover(
		function () {
			clearInterval(tabTimer);
		},
		function () {
			fadeOutTab();
		},
	);

	function fadeOutTab() {
		tabTimer = setTimeout(function () {
			$(".tabBox").stop().fadeOut(300);
			$("#bgWhite").stop().fadeOut(300);
			$("header").removeClass("whiteBgTab");
		}, 400);
	}

	$(".tabBtnClick").click(function () {
		var linkBtn = $(this);
		$(".tabBtn").not(linkBtn).removeClass("activeTab");
		linkBtn.toggleClass("activeTab");

		var target = linkBtn.data("tab");
		target = "#" + target;
		target = $(target);

		if (linkBtn.hasClass("activeTab")) {
			//open
			$(".tabBox").not(target).hide();

			target.stop().fadeIn(300);
			$("#bgWhite").stop().fadeIn(300);
			$("header").addClass("whiteBgTab");
		} else {
			//close
			$(".tabBox").stop().fadeOut(300);
			$("#bgWhite").stop().fadeOut(300);
			$("header").removeClass("whiteBgTab");
		}

		return false;
	});

	$(".subNavList .hoverImg").hover(
		function () {
			var box = $(this).closest(".container");
			var list = $(this).closest(".subNavList");
			var btn = $(this);
			var index = list.find("li").index(btn);
			//console.log(index);

			box.find(".imgList li").not(index).removeClass("active");
			box.find(".imgList li").eq(index).addClass("active");
		},
		function () {},
	);

	$("#bgWhite,.closeBtn").click(function () {
		$(".tabBtn").removeClass("activeTab");
		$(".filterBtn").removeClass("activeTab");

		$(".tabBox").stop().fadeOut(300);
		$("#bgWhite").stop().fadeOut(300);

		//menu
		$("html,body").removeClass("hiddenBox");
		$("#toggle").removeClass("active");
		$("#overlay").removeClass("open");
		$("header").removeClass("menuOpen");
		$("header").removeClass("whiteBgTab");

		return false;
	});

	$(".headNews .closeBtn").click(function () {
		$(".headNews").slideUp(300);

		$("main").addClass("mini");
		$("#button_container").addClass("mini");
	});

	/*-------------------------------------
TOP
-------------------------------------*/

	var bestSwiper = new Swiper(".bestSwiper", {
		// Optional parameters
		loop: false,
		slidesPerView: 3.5,
		spaceBetween: 10,
		centeredSlides: false,
		breakpoints: {
			// when window width is >= 719px
			719: {
				slidesPerView: 4.7,
				spaceBetween: 12,
				centeredSlides: false,
			},
		},

		// pagination: {
		// 	el: ".swiper-pagination",
		// },

		// navigation: {
		// 	nextEl: ".swiper-button-next",
		// 	prevEl: ".swiper-button-prev",
		// },

		// scrollbar: {
		// 	el: ".swiper-scrollbar",
		// },
	});
	var collectionSwiper = new Swiper(".collectionSwiper", {
		// Optional parameters
		loop: false,
		slidesPerView: 1.5,
		spaceBetween: 10,
		centeredSlides: false,
		breakpoints: {
			// when window width is >= 719px
			719: {
				slidesPerView: 3,
				spaceBetween: 18,
				centeredSlides: false,
			},
		},

		// pagination: {
		// 	el: ".swiper-pagination",
		// },

		// navigation: {
		// 	nextEl: ".swiper-button-next",
		// 	prevEl: ".swiper-button-prev",
		// },

		// scrollbar: {
		// 	el: ".swiper-scrollbar",
		// },
	});

//recently-prouct-slider.liquid
//ft-checked.liquid
	var checkSwiper = new Swiper(".checkSwiper", {
		// Optional parameters
		loop: false,
		slidesPerView: 3.5,
		spaceBetween: 10,
		centeredSlides: false,
		breakpoints: {
			// when window width is >= 719px
			719: {
				slidesPerView: 8,
				spaceBetween: 12,
				centeredSlides: false,
			},
		},

		// pagination: {
		// 	el: ".swiper-pagination",
		// },

		// navigation: {
		// 	nextEl: ".swiper-button-next",
		// 	prevEl: ".swiper-button-prev",
		// },

		// scrollbar: {
		// 	el: ".swiper-scrollbar",
		// },
	});

	/*-------------------------------------
LIST
-------------------------------------*/

	$(".largeBtn").click(function () {
		$(".smallBtn").removeClass("active");
		$(".largeBtn").addClass("active");
		$(".itemList").addClass("moveFast");

		$(".itemList").addClass("large");
		$(".itemList").removeClass("small");

		setTimeout(function () {
			$(".itemList").removeClass("moveFast");
			$(window).trigger("resize");
		}, 600);

		return false;
	});
	$(".smallBtn").click(function () {
		$(".smallBtn").addClass("active");
		$(".largeBtn").removeClass("active");
		$(".itemList").addClass("moveFast");

		$(".itemList").removeClass("large");
		$(".itemList").addClass("small");

		setTimeout(function () {
			$(".itemList").removeClass("moveFast");
			$(window).trigger("resize");
		}, 600);

		return false;
	});

	$(".sortBtn").click(function () {
		$(this).next(".filterSelect").slideToggle(300);

		return false;
	});
	$(".filterBtn").click(function () {
		var linkBtn = $(this);
		$(".tabBtn").not(linkBtn).removeClass("activeTab");
		linkBtn.toggleClass("activeTab");

		var target = linkBtn.data("tab");
		target = "#" + target;
		target = $(target);

		if (linkBtn.hasClass("activeTab")) {
			//open
			$(".tabBox").not(target).hide();

			target.stop().fadeIn(300);
			$("#bgWhite").stop().fadeIn(300);
			$("header").addClass("whiteBgTab");
		} else {
			//close
			$(".tabBox").stop().fadeOut(300);
			$("#bgWhite").stop().fadeOut(300);
			$("header").removeClass("whiteBgTab");
		}

		return false;
	});

	// $(".colorList li a").click(function () {
	// 	var box = $(this).closest(".itemList > li");
	// 	box.find(".colorList li a").removeClass("active");
	// 	$(this).addClass("active");

	// 	var url = $(this).data("url");
	// 	var img = $(this).data("img-url");

	// 	box.find(".img a").attr("href", url);
	// 	box.find(".img a img").attr("src", img);

	// 	return false;
	// });

	// const legArr = ["STEEL PIPE LEG", "L LEG", "SQUARE LEG", "FOLDING LOW LEG", "FOLDING LEG", "COMPASS WOOD LEG", "POLE LEG-S", "POLE LEG-C", "TOP CIRCLE", "TOP SQUARE"];

	// $(".itemList > li").each(function (index) {
	// 	var tmp = $(this);
	// 	var ttl = tmp.find(".ttl").text();

	// 	if (ttl.indexOf("SEMIORDER") != -1) {
	// 		//console.log(ttl);

	// 		//SEMIORDERを含む場合の処理
	// 		for (var i = 0; i < legArr.length; i++) {
	// 			var word = legArr[i];
	// 			//console.log(word);

	// 			if (ttl.indexOf(word) != -1) {
	// 				var ttl2 = ttl.replace(" " + word, "");
	// 				tmp.find(".ttl").text(ttl2);
	// 				tmp.find(".subTtl").text(word);

	// 				break;
	// 			}
	// 		}
	// 	}
	// });

	/*-------------------------------------
DETAIL
-------------------------------------*/

	var detailSwiper;
	var breakpoint = 719;
	var detailSwiperFlg = false;

	var swiperOptions = {
		watchOverflow: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		preventInteractionOnTransition: true,

		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},

		pagination: {
			el: "#galleryMainPagination",
			clickable: true,
		},
	};

	function createDetailSwiper() {
		detailSwiper = new Swiper(".galleryMain", swiperOptions);
	}

	if (www < breakpoint) {
		$(".swiper-wrapper-tmp").addClass("swiper-wrapper");
		createDetailSwiper();
		detailSwiperFlg = true;
	} else {
		$(".swiper-wrapper-tmp").removeClass("swiper-wrapper");
		detailSwiperFlg = false;
	}

	$(window).on("resize", adjustGallery);

	function adjustGallery() {
		www = $(window).width();
		hhh = $(window).height();

		if (www < breakpoint && !detailSwiperFlg) {
			$(".swiper-wrapper-tmp").addClass("swiper-wrapper");
			createDetailSwiper();
			detailSwiperFlg = true;
		} else if (www >= breakpoint && detailSwiperFlg) {
			detailSwiper.destroy(false, true);
			$(".swiper-wrapper-tmp").removeClass("swiper-wrapper");
			detailSwiperFlg = false;
		}
	}

	$(".tabLit li").click(function () {
		var linkBtn = $(this);
		$(".tabLit li").not(linkBtn).removeClass("active");
		linkBtn.addClass("active");

		var target = linkBtn.data("tab");
		target = "#" + target;
		target = $(target);

		if (linkBtn.hasClass("active")) {
			//open
			$(".miniTab").not(target).hide();

			target.stop().fadeIn(300);
		} else {
			//close
			//$(".miniTab").stop().fadeOut(300);
		}

		return false;
	});

	$(".wishlist").click(function () {
		var linkBtn = $(this);
		linkBtn.toggleClass("active");

		return false;
	});

	$(".openBtn").click(function () {
		var target = $(this).closest(".each");
		target.toggleClass("active");

		target.find(".despArea").fadeToggle(300);

		return false;
	});

	// var speed = 300;

	// $(".popup").click(function () {
	// 	$("html,body").addClass("hiddenBox");
	// 	$(".collectionModal").addClass("active");

	// 	var targetName = $(this).attr("href");
	// 	var target = $(targetName);

	// 	var scrolled = $(".collectionModal").scrollTop();
	// 	//$(".collectionModal").animate({scrollTop:0}, 10, "swing");

	// 	setTimeout(function () {
	// 		//console.log(targetName);
	// 		//console.log(target);
	// 		//console.log(target.position().top+scrolled);

	// 		www = $(window).width();
	// 		var sa = 0;

	// 		if (www > 719) {
	// 			sa = -0;
	// 		} else {
	// 			sa = -0;
	// 		}

	// 		var position = target.position().top + scrolled;
	// 		$(".collectionModal").animate({ scrollTop: position }, speed, "swing");
	// 	}, 300);

	// 	return false;
	// });
	// $(".collectionModal .closeBtn").click(function () {
	// 	$(".collectionModal").removeClass("active");
	// 	$("html,body").removeClass("hiddenBox");

	// 	//$(".collectionModal").animate({scrollTop:0}, speed, "swing");
	// });

	// document.addEventListener("keydown", function (e) {
	// 	$(".collectionModal").removeClass("active");
	// 	$("html,body").removeClass("hiddenBox");
	// });

	/*-------------------------------------
DEAIL
-------------------------------------*/

	function checkColor() {
		var selectColor = $(".product-form__input input[name=COLOR]:checked");
		var selectColorText = selectColor.val();
		//console.log(selectColor);

		if (selectColor != "") {
			//$("#wrapper .itemBox .itemContent .color").text(selectColorText);
			$("#wrapper .itemBox .popupAddCart .popupAddCartContainer .despBox .popupColor").text(selectColorText);
		}
		//console.log(selectColor.data("media"));

		var mediaID = selectColor.data("media");

		var targetImg = $(".detailSlider li[data-media-id=" + mediaID + "]");
		//console.log(targetImg);

		$(".detailSlider li").removeClass("current");
		targetImg.addClass("current");

		$("html, body").animate({ scrollTop: 0 }, 0, "swing");

		$(".add_cart_btn").removeClass("added");
		$(".popupAddCart a").removeClass("active");
		$(".add_cart_btn").find("span").text("ADD TO CART");
	}
	checkColor();

	$(".product-form__input input[name=COLOR]").change(function () {
		checkColor();
	});

	$(".tabList li").click(function () {
		var target = $(this).data("tab");

		//$(".tabAllBox .tabBox").stop().fadeOut(300);
		$(".tabAllBox .tabBox").stop().hide();
		$(target).stop().fadeIn(600);

		$(".tabList li").removeClass("active");
		$(this).addClass("active");

		return false;
	});

	$(".add_cart_btn").click(function () {
		$(this).addClass("added");
		$(".popupAddCart a").addClass("active");
		$(this).find("span").text("ADDED");

		//return false;
	});
	$(".popupClose").click(function () {
		$(".add_cart_btn").removeClass("added");
		$(".popupAddCart a").removeClass("active");
		$(".add_cart_btn").find("span").text("ADD TO CART");

		return false;
	});

	/*-------------------------------------
RESIZE
-------------------------------------*/

	$(window).on("resize", adjustResize);

	function adjustResize() {
		www = $(window).width();
		hhh = $(window).height();
	}
	adjustResize();

	/*-------------------------------------
POPUP
-------------------------------------*/

	var preTop;
	var www;

	www = $(window).width();

	var args = {
		delegate: "a.popup",
		type: "inline",
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: "mfp-img-mobile mfp-fade",
		closeOnBgClick: true,
		removalDelay: 300,

		gallery: {
			enabled: true,
		},
		callbacks: {
			open: function () {
				preTop = $(window).scrollTop();
				$("html,body").addClass("hiddenBox");
				setTimeout(function () {
					$("html,body").addClass("hiddenBox");
				}, 100);

				$("html, body").animate({ scrollTop: preTop }, 0, "swing");

				setTimeout(function () {
					$(window).on("resize", adjustResize);
				}, 300);
			},
			beforeClose: function () {
				//$("html, body").animate({scrollTop:preTop}, 0, "swing");
			},
			close: function () {
				$("html,body").removeClass("hiddenBox");

				//$("html, body").animate({scrollTop:preTop}, 0, "swing");

				$(window).trigger("resize");
			},

			change: function () {},
		},
	};

	//$('#tokyo').magnificPopup(args);

	setTimeout(function () {
		$("body").addClass("active");
	}, 300);

	setTimeout(function () {
		$(".pageTtl").addClass("active");
	}, 1000);

	/*-------------------------------------
WAYPOINT
-------------------------------------*/

	www = $(window).width();

	if (www > 719) {
		var ppp = "80%";
	} else {
		var ppp = "70%";
	}

	$(".fadeSimple").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fade").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fadeFast").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: "90%" },
	);

	$(".fadeLeft").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fadeLeftSp").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fadeRight").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskRight").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskLeft").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskTop").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskBottom").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".waypoint").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);
	$(".lookContent .box .each").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("show");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);
	$(".lookGridList .each").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("show");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	/*-------------------------------------
COMMON
-------------------------------------*/

	function commonEvent() {
		adjustResize();

		$("a.scroll").click(function () {
			//$.magnificPopup.close();

			var speed = 500;
			var href = $(this).attr("href");
			if (href == "#" || href == "") {
				var target = "html";
			} else {
				var target = $(href);

				www = $(window).width();
				var sa = 0;

				if (www > 980) {
					sa = 0;
				} else {
					sa = 0;
				}

				var position = target.offset().top - sa;

				hideFlg = false;
				$("header").addClass("hide");

				$("html, body").animate({ scrollTop: position }, speed, "swing");

				setTimeout(function () {
					hideFlg = true;
				}, 600);

				return false;
			}
		});

		var topBtn = $("#pagetop");

		//スクロールしてトップ
		topBtn.click(function () {
			$("body,html").animate(
				{
					scrollTop: 0,
				},
				500,
			);
			return false;
		});
	}
	commonEvent();
});
